<template>
    <div class="page flex flex-col md:border-l md:border-r">
        <TopBarBg
            :headerText="lbl.privacymenu.mkt_setting.title"
            small
            multiLineTitle
            :canGoBack="true"
        ></TopBarBg>
        <PageContent
            class="flex-auto px-6"
            :hasPoweredBy="hasPoweredBy"
            rounded
            :marginTop="55"
            :paddingTop="0">

            <div class="mt-10">
                <div class="text-base h-full overflow-y-auto py-5" v-html="marketingContent"></div>
            </div>

        </PageContent>
        <div class="flex justify-between mb-4 items-center px-6">
            <div v-if="acceptedText">{{ lbl.register.buttons.unaccept }}</div>
            <div v-else>{{ lbl.register.buttons.accept }}</div>
            <div @click="handleToggleMkt('sms')">
                <img v-if="checkedAccept" class="h-6 w-auto" src="../../../assets/icon/dialog/toggle_active.png" />
                <img v-else class="h-6 w-auto" src="../../../assets/icon/dialog/toggle_inactive.png" />
            </div>
        </div>
        <div class="px-6 pb-8">
            <VBtn
                v-if="checkedAccept"
                @click="saveConsent()"
                blocked
                large
                variant="primary">
                {{ lbl.default.save }}
            </VBtn>
            <VBtn
                v-else
                blocked
                large
                variant="disable"
            >{{ lbl.default.save }}</VBtn>
        </div>
        <Footer :hasPoweredBy="false"></Footer>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>

    <div class="flyout-zone">
        <VBottomSheet v-model="bottomSheetSuccess" :persistent="false">
            <div class="px-6 -mt-10 text-center relative">
                <div class="mb-4">
                    <img src="@/assets/icon/dialog/success.svg" class="w-20 h-20 mx-auto" alt />
                </div>
                <div class="absolute right-5 top-14">
                    <img class="h-4 w-auto" @click="clickClose()" src="../../../assets/icon/dialog/close.svg" />
                </div>
                <div>
                    <div class="text-lg text-primary uppercase mt-5" v-html="lbl.privacymenu.save_success_title"></div>
                    <div class="mt-6 mb-8 text-gray-secondary" v-html="lbl.privacymenu.save_success_msg"></div>
                </div>
            </div>
            <Footer :hasPoweredBy="false" />
        </VBottomSheet>
    </div>
</template>
<script>
import Account from '@/helper/AccountHelper.js';
//component
import TopBarBg from "@/components/Layout/TopBar/TopBarBg.vue";
import PageContent from "@/components/Layout/Content/PageContent.vue";
import VBottomSheet from "@/components/Dialog/BottomSheet.vue"
//mixin
import AuthPageMixin from "@/mixin/AuthPageMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
import Footer from "@/components/Layout/Footer/Footer.vue";
import VBtn from "@/components/Button/VBtn.vue"
import BzbsPDPA from "@/core/PDPA/service/BzbsPDPA.js";
// import { HistoryPointConfigBuilder } from "@/core/Point/config/PointConfigModel.js";

export default {
    name: "History",
    mixins: [ModalMixin, AuthPageMixin, LocaleMixin],
    components: {
        TopBarBg,
        PageContent,
        Footer,
        VBtn,
        VBottomSheet
    },
    data: function () {
        return {
            purchaseListConfig: null,
            purchaseFilterListConfig: null,
            tab: 0,
            tabs: ["Redeemed", "Used / Expired"],
            isExpired: false,
            hasPoweredBy: false,
            trackingScreenName: "marketing_setting",
            mktObject: {
                all: false,
                email: false,
                sms: false,
                noti: false,
                marketingOption: false,
            },
            marketingVersion: 0,
            bottomSheetSuccess: false,
            marketingContent: '',
            checkedAccept: false,
            acceptedText: false,
            smsAndMkt: {
                sms: false,
                marketingOption: false,
            },
            oldMktObject: {
                sms: null,
                marketingOption: null,
            }
        };
    },
    created: function () {

        this.tracking.screenName(this.trackingScreenName);

    },
    mounted: async function () {
        this.loadingModal.show();
        await this.setupTermsAndPrivacy();
        await this.getConsent();
        this.loadingModal.hide();
    },
    methods: {
        setupTermsAndPrivacy: function () {
            BzbsPDPA.apiGetPDPAVersion().subscribe(
                {
                    next: (data) => {
                        this.marketingVersion = data.marketing.current_version

                        this.apiGetMarketing();
                    },
                    error: (err) => {
                        this.errorApi(err)
                    }
                }
            )
        },
        apiGetMarketing: function () {
            BzbsPDPA.apiGetPDPAContent('marketing', this.marketingVersion, this.localeCode + '.txt').subscribe({
                next: (data) => {
                    this.marketingContent = data
                },
                error: (err) => {
                    this.errorApi(err)
                }
            })
        },
        getConsent: function() {
            var token = Account.getToken();
            return new Promise((resolve)=>{

                BzbsPDPA.apiGetConsent(token)
                    .subscribe((data) => {
                        console.log(data);
                        var isCheckAll = true;
                        if (data.MarketingOption) {
                            this.mktObject.marketingOption = true;
                            this.smsAndMkt.marketingOption = true;
                            this.oldMktObject.marketingOption =  this.marketingVersion;
                        } else {
                            isCheckAll = false;
                            this.oldMktObject.marketingOption =  0;
                        }
                        if (data.EmailMarketing) {
                            this.mktObject.email = true;
                        } else {
                            isCheckAll = false;
                        }
                        if (data.SMSMarketing) {
                            this.mktObject.sms = true;
                            this.smsAndMkt.sms = true;
                            this.oldMktObject.sms =  this.marketingVersion;
                        } else {
                            isCheckAll = false;
                            this.oldMktObject.sms =  0;
                        }
                        if (data.NotificationMarketing) {
                            this.mktObject.noti = true;
                        } else {
                            isCheckAll = false;
                        }
                        if (isCheckAll) {
                            this.mktObject.all = true;
                        }
                        if (data.MarketingOption != 0 && data.SMSMarketing != 0) {
                            this.acceptedText = true;
                        }
                        resolve();

                    }, (err) => {
                        this.loadingModal.hide();
                        this.errorApi(err);
                    });
            });
        },
        getPdpaVersion: function() {
            return new Promise((resolve, reject) => {

                BzbsPDPA.apiGetPDPAVersion().subscribe(
                    res => {
                        this.marketingVersion = res.marketing.current_version;
                        resolve();
                    },
                    err => {
                        this.errorApi(err);
                        reject();
                    }
                );
            });
        },
        saveConsent: async function () {

            this.loadingModal.show();
            await this.getPdpaVersion();
            // var dataMkt = {
            //     email: this.mktObject.email ? this.marketingVersion : 0,
            //     sms: this.mktObject.sms ? this.marketingVersion : 0,
            //     notification: this.mktObject.noti ? this.marketingVersion : 0,
            //     marketingOption: this.mktObject.marketingOption ? this.marketingVersion : 0,
            // }
            let dataMkt = null;
            if (this.smsAndMkt.sms && this.smsAndMkt.marketingOption && this.checkedAccept) {
                // ยอมรับแล้วกดไม่ยอมรับ
                dataMkt = {
                    sms: 0,
                    marketingOption: 0
                }
            } else if (!this.smsAndMkt.sms && !this.smsAndMkt.marketingOption && this.checkedAccept) {
                // ไม่ยอมรับแล้วกดยอมรับ
                dataMkt = {
                    sms: this.marketingVersion,
                    marketingOption: this.marketingVersion
                }
            } else {
                // เข้ามาแล้วไม่อะไรเลย
                dataMkt = {
                    sms: this.oldMktObject.sms,
                    marketingOption: this.oldMktObject.marketingOption
                }
            }
            var token = Account.getToken();
            return new Promise((resolve)=>{
                //marketingVersion
                BzbsPDPA.apiPostConsent(token, null, null, dataMkt)
                    .subscribe((data) => {
                        console.log(data);
                        this.loadingModal.hide();

                        this.bottomSheetSuccess = true;
                        resolve();

                    }, (err) => {
                        this.loadingModal.hide();
                        this.errorApi(err);
                    });
            });
        },
        handleToggleMkt: function (type) {
            if (type == 'email') {
                this.mktObject.email = !this.mktObject.email;
            }
            if (type == 'sms') {
                this.mktObject.sms = !this.mktObject.sms;
                this.mktObject.marketingOption = !this.mktObject.marketingOption;
                this.checkedAccept = !this.checkedAccept;
            }
            if (type == 'noti') {
                this.mktObject.noti = !this.mktObject.noti;
            }
            if (type == 'all') {
                this.mktObject.all = !this.mktObject.all;
                if (this.mktObject.all) {
                    this.mktObject.email = true;
                    this.mktObject.sms = true;
                    this.mktObject.noti = true;
                } else {
                    this.mktObject.email = false;
                    this.mktObject.sms = false;
                    this.mktObject.noti = false;
                }

            }
            if (this.mktObject.email && this.mktObject.sms && this.mktObject.noti) {
                this.mktObject.all = true;
            } else {
                this.mktObject.all = false;
            }
        },
        clickClose: function() {
            this.bottomSheetSuccess = false;
            this.$router.back();
        },
    },
};
</script>
<style lang="scss" scoped>
</style>
